module.exports = __webpack_public_path__ + "media/images/sponsorBanner__right__top-34c3c7dae1e41d8db8391312b2e253d3.png";